<template>
  <div
    ref='root'
    v-show='visible'
    class='popup confirm'
  >
    <div class='content'>
      <ul class="text">
        <li>
          <p><a href="https://docs.emarf.co/1515709244d2809ea9a9c8a349bdcc16" target="_blank">{{ $t('フィレット') }}</a>・<a href="https://docs.emarf.co/1515709244d280ada6f8f71c839459c9" target="_blank">{{ $t('オフセット') }}</a>{{ $t('はデータに反映されていますか？') }}</p>
        </li>
        <li>
          <p><a href="https://docs.emarf.co/1515709244d280c4a3effd77db4e4d9d#1525709244d280c995efd5a81f356ac9" target="_blank">{{ $t('ラワン合板とCLTには裏表があります。') }}</a> {{ $t('気になる場合は備考欄で希望をお伝え下さい。') }}</p>
        </li>
        <li class="no-disc">
          <div class='button-wrapper'>
            <a class='button cancel' @click.prevent.stop='hide' data-ga-click-event="フィレット・オフセット戻る">{{ $t('戻る') }}</a>
            <a class='button confirmBtn' @click.stop='$emit("order")' data-ga-click-event="フィレット・オフセット確認">OK</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

import PopupBase from './PopupBase.vue';

export default {
  name: 'ConfirmPopup',
  extends: PopupBase,
  data () {
    return {
      name: ''
    };
  }
};

</script>

<style lang="scss" scoped>

ul.text {
  text-align: left;
  padding-left: 24px;

  .no-disc{
    list-style: none;
    text-align: center;
  }

  li {
    margin-bottom: 4px;
    list-style: disc;
    list-style-position: outside;
    text-align: left;
    p {
      display: inline;
      text-align: left;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ConfirmPopup.vue